export default function RTFBreakline(): React.ReactNode {
  return <br />;
}
